export { default } from './ClassNotesSection';
